var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4068B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0004 7.00333L16.9255 7C14.5946 7 13.0882 8.54552 13.0882 10.9376V12.7531H11.002C10.8218 12.7531 10.6758 12.8993 10.6758 13.0795V15.71C10.6758 15.8903 10.8219 16.0363 11.002 16.0363H13.0882V22.6738C13.0882 22.854 13.2341 23 13.4144 23H16.1362C16.3165 23 16.4625 22.8539 16.4625 22.6738V16.0363H18.9017C19.0819 16.0363 19.2279 15.8903 19.2279 15.71L19.2289 13.0795C19.2289 12.993 19.1944 12.9101 19.1334 12.8488C19.0723 12.7876 18.989 12.7531 18.9025 12.7531H16.4625V11.2141C16.4625 10.4744 16.6387 10.0989 17.6023 10.0989L19 10.0984C19.1801 10.0984 19.3261 9.95222 19.3261 9.77211V7.32958C19.3261 7.14964 19.1803 7.00366 19.0004 7.00333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicon);
export default __webpack_public_path__ + "static/media/facebookicon.74a33e36.svg";
export { ForwardRef as ReactComponent };